import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FiChevronLeft, FiChevronRight, FiUser } from 'react-icons/fi';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import { AiFillPhone } from 'react-icons/ai';
import { MdEmail, MdPerson } from 'react-icons/md';
import { IoIosContacts } from 'react-icons/io';

const contacts = [
  {
    id: 'direction',
    labelKey: 'direction',
    name: 'M Eric Gastine',
    phone: '07 61 01 77 50',
    email: 'eric.gastine@itmsol.fr',
  },
  {
    id: 'operations',
    labelKey: 'operations',
    name: 'M Xavier Lelong',
    phone: '06 21 43 68 97',
    email: 'xavier.lelong@itmsol.fr',
  },
  {
    id: 'maintenance',
    labelKey: 'maintenance',
    name: 'M Maxance Lu',
    phone: '06 68 09 23 94',
    email: 'maxance.lu@itmsol.fr',
  },
];

const sanitizePhone = (phone) => phone.replace(/\s+/g, '');

const WidgetContact = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);

  const updateScrollState = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const maxScroll = el.scrollWidth - el.clientWidth;
    setHasOverflow(maxScroll > 1);
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < maxScroll - 1);
  }, []);

  useEffect(() => {
    updateScrollState();
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => updateScrollState();
    el.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateScrollState);

    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateScrollState);
    };
  }, [updateScrollState]);

  const getScrollAmount = () => {
    const el = scrollRef.current;
    if (!el) return 300;
    const card = el.querySelector('[data-contact-card]');
    const styles = window.getComputedStyle(el);
    const gapValue = parseFloat(styles.columnGap || styles.gap || '0');
    const cardWidth = card ? card.getBoundingClientRect().width : el.clientWidth;
    return cardWidth + (Number.isFinite(gapValue) ? gapValue : 0);
  };

  const handleScrollBy = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = getScrollAmount();
    el.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  return (
    <div className={[S.widget, S.widgetSmall, S.widgetContactBox].join(' ')}>
      <div className={S.contactContainer}>
        <div className={S.contactHeader}>
          <div>
            <span className={S.contactTitle}>{checkMot('contacts_itmsol')}</span>
          </div>
          <div className={S.contactIconCircle}>
            <FiUser size={18} />
          </div>
        </div>

        <div className={S.contactListWrapper}>
          {hasOverflow && (
            <>
              <button
                type="button"
                className={[
                  S.scrollButton,
                  S.scrollButtonLeft,
                  !canScrollLeft ? S.scrollButtonDisabled : '',
                ].join(' ')}
                onClick={() => handleScrollBy(-1)}
                aria-label="Faire défiler les contacts vers la gauche"
                disabled={!canScrollLeft}
              >
                <FiChevronLeft size={16} />
              </button>
              <button
                type="button"
                className={[
                  S.scrollButton,
                  S.scrollButtonRight,
                  !canScrollRight ? S.scrollButtonDisabled : '',
                ].join(' ')}
                onClick={() => handleScrollBy(1)}
                aria-label="Faire défiler les contacts vers la droite"
                disabled={!canScrollRight}
              >
                <FiChevronRight size={16} />
              </button>
            </>
          )}
          <div className={S.contactCarousel}>
            <div className={S.contactList} ref={scrollRef}>
              {contacts.map((contact) => (
                <div
                  className={S.contactCard}
                  key={contact.id}
                  data-contact-card
                >
                  <div className={S.contactCardTitle}>
                    <IoIosContacts size={18} />
                    <span>{checkMot(contact.labelKey)}</span>
                  </div>
                  <div className={S.contactCardBody}>
                    <div className={S.contactLine}>
                      <MdPerson size={18} color="#eeb214" />
                      <span>{contact.name}</span>
                    </div>
                    <div className={S.contactLine}>
                      <AiFillPhone size={18} color="#eeb214" />
                      <a href={`tel:${sanitizePhone(contact.phone)}`}>
                        {contact.phone}
                      </a>
                    </div>
                    <div className={S.contactLine}>
                      <MdEmail size={18} color="#eeb214" />
                      <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetContact;
